<template>
  <div>
    <Skeletor class="disk-skeletor-elem" width="100" as="div" />
    <Skeletor class="disk-skeletor-elem" as="div" />
  </div>
</template>
